import { TRaffleDealV3ItemPayload } from '@/models/RaffleDeal/interfaces/IRaffleDealPromotionsPayload';
import { RaffleDealStoreCtx } from '@/stores/RaffleDealStore';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import moment from 'moment-timezone';
import { propEq } from 'ramda';
import React, { useContext, useMemo } from 'react';

import styles from './RaffleDealExpectedProductUnit.module.scss';

interface IRaffleDealExpectedProductUnitProps {
  deal: TRaffleDealV3ItemPayload | undefined;
}

const RaffleDealExpectedProductUnit: React.FC<IRaffleDealExpectedProductUnitProps> = ({ deal }) => {
  const store = useContext(RaffleDealStoreCtx);

  const { images } = store.PromotionData;
  const noScheduledImg = useMemo(() => images.filter(propEq('section', 'NO_SCHEDULED')).sort()?.[0], [images]);

  if (!deal) {
    return (
      <div className={clsx([styles.container, 'swiper-slide'])}>
        <img
          className={styles.commingSoon}
          src={noScheduledImg?.url}
          alt={noScheduledImg?.altText || '예정상품 없을'}
        />
      </div>
    );
  }

  const startAt = moment(deal.startAt || '').format('M월 D일 a HH시');

  return (
    <div className={clsx([styles.container, 'swiper-slide'])}>
      <img className={styles.image} src={deal.imageUrl} alt={deal.productName} />

      <div className={styles.dateInfo}>{startAt}</div>

      <div className={styles.infoWrap}>
        <div>
          <p className={styles.productName}>{deal.productName}</p>
          <p className={styles.productDesc}>{deal.productDescription}</p>
        </div>
        <div>
          <p className={styles.originPrice}>{deal.regularPriceText}</p>
          <div className={styles.priceWrap}>
            <p className={styles.percent}>{deal.discountRateText}</p>
            <p className={styles.price}>{deal.discountPriceText}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(RaffleDealExpectedProductUnit);
